module.exports = __webpack_public_path__ + "static/blocks-image-bc768f51bf99b979fcd6b5c1ae38cd7a.svg";